import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import ReactPaginate from 'react-paginate'

import BadIcon from '../../assets/img/svg/bad-icon.svg'
import ShawerIcon from '../../assets/img/svg/shawer-icon.svg'
import StatusModal from '../../component/modal/statusModal'
import { defaultUserImg, FilterIcon } from '../../helper/imagepath'
import { getAllOverview } from '../../redux/slices/overviewSlice'
import { SpinnerContext } from '../../context/spinnerContext'
import { getAllRegion } from '../../redux/slices/regionSlice'
import {
  checkIfPastDate,
  convertTimestampToDate,
  convertTimestampToTime,
  formatAmount,
  getBookingStatusClass,
  getDayStartAndEndTimestamps,
  getTimeStamp,
  getUserRole,
  hasAccess
} from '../../helper/function'
import { getSchedulePropertyDataById } from '../../redux/slices/propertySlice'

import CancelModalContent from '../../component/scheduleStatus/canceleModalContent'
import ScheduledModalContent from '../../component/scheduleStatus/scheduledModalContent'

import OverviewFilter from './overviewFilter'
import { errorToast } from '../../util/Toast/toast'

const OverView = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const itemsPerPage = 6
  const { changeLoader } = useContext(SpinnerContext)
  const { allOverview } = useSelector((state) => state.overView)
  const { scheduledProperties } = useSelector((state) => state.property)
  const [currentPage, setCurrentPage] = useState(allOverview?.currentpage || 1)
  const [showFilter, setShowFilter] = useState(false)
  const [filterData, setFilterData] = useState({})
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [modalName, setModalName] = useState(null)
  const [loading, setLoading] = useState(false)

  // eslint-disable-next-line no-unused-vars
  const [isRefresh, setIsRefresh] = useState(false)
  const [chatUserId, setChatUserId] = useState(null)

  const pageCount = useMemo(
    () => (allOverview?.totalRecords <= 0 ? 0 : Math.ceil(allOverview?.totalRecords / itemsPerPage)),
    [allOverview, itemsPerPage]
  )
  const clientName = useMemo(
    () =>
      scheduledProperties?.getPropertyScheduleData?.properties?.client
        ? scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name +
          ' ' +
          scheduledProperties?.getPropertyScheduleData?.properties?.client?.last_name
        : '',
    [scheduledProperties?.getPropertyScheduleData]
  )
  const getOverviewData = useCallback(() => {
    const { endOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(filterData?.created_end))
    setLoading(true)
    // Prepare the parameters for the API call
    const params = {
      page: currentPage,
      limit: itemsPerPage,
      sort_column: 'booking_date_time',
      sort_order: 'DESC',
      ...(filterData?.hostname && { host_name: filterData.hostname }),
      ...(filterData?.cleaner && { cleaner_name: filterData.cleaner }),
      ...(filterData?.region && { region_id: filterData.region }),
      ...(filterData?.city_id && { city_id: filterData.city_id }),
      ...(filterData?.created_start && { startTimestamps: filterData?.created_start && getTimeStamp(filterData?.created_start) }),
      ...(filterData?.created_end && { endTimestamps: filterData?.created_end && endOfDayTimestamp }),
      ...(filterData?.booking_status && { booking_status: filterData.booking_status })
    }
    changeLoader(true)
    dispatch(getAllOverview(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
          setLoading(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
          setIsRefresh(false)
          setLoading(false)
        }
      })

      .catch((err) => {
        console.log('err :>> ', err)
        changeLoader(false)
        setIsRefresh(false)
        setLoading(false)
      })
  }, [itemsPerPage, currentPage, isRefresh, filterData])

  const getStateCityData = useCallback(() => {
    dispatch(getAllRegion())
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }, [])

  useEffect(() => {
    getStateCityData()
  }, [])

  useEffect(() => {
    getOverviewData()
  }, [itemsPerPage, currentPage, isRefresh, filterData])

  const handlePageChange = useCallback((selectedItem) => {
    setCurrentPage(selectedItem?.selected + 1) // Add 1 to the index to start from 1
  }, [])

  const onHandleDetails = useCallback(
    (data) => {
      const { booking_status, property_schedule_id } = data
      setChatUserId(property_schedule_id)
      if (['scheduled', 'canceled', 'in progress', 'canceled cleaner']?.includes(booking_status)) {
        getPropertyData(property_schedule_id, booking_status)
      } else if (['completed']?.includes(booking_status)) {
        navigate(`/${`overview`}/complete-cleaning/${property_schedule_id}/cleaningDetail`)
      }
    },
    [navigate]
  )

  const getPropertyData = async (schedule_id, status) => {
    changeLoader(true)
    await dispatch(getSchedulePropertyDataById(schedule_id))
      .then(() => {
        setIsStatusModalOpen(true)
        setModalName(status)
        changeLoader(false)
      })
      .catch((err) => {
        console.log('err :>> ', err)
        changeLoader(false)
      })
  }

  const handlePagination = async (page) => {
    setCurrentPage(page)
  }

  const overFun = useMemo(() => {
    return scheduledProperties?.getPropertyScheduleData?.next_checkin_time
      ? checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.next_checkin_time, false)
      : checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.booking_date_time, true)
  }, [scheduledProperties?.getPropertyScheduleData])

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Headers */}
        <div className="page-header">
          <div className="content-page-header">
            <h5>Overview</h5>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                    <span className="me-2">
                      <img src={FilterIcon} alt="filter" />
                    </span>
                    Filter
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="row">
          {/* Actual code here */}
          {allOverview?.scheduledProperties?.length > 0
            ? allOverview?.scheduledProperties?.map((item, index) => (
                <div className="col-md-12 col-lg-6 col-xl-6" key={`overview-card-${index}`}>
                  <div className="common_card_div upcoming_cleanings_space_div">
                    <div className="upcoming_cleanings_box_div">
                      <div className="upcoming_cleanings_inner_box upcoming_cleanings_flex_div mb-2">
                        <div className="user_img_div">
                          <div className="cleanings_img_div">
                            <img className="img-fluid" src={defaultUserImg} alt="Image" />
                          </div>
                          <div className="user_right_contains">
                            {item?.properties?.client?.first_name ? (
                              <h6 className="mb-0">{`${item?.properties?.client?.first_name} ${item?.properties?.client?.last_name}`}</h6>
                            ) : (
                              '-'
                            )}
                          </div>
                        </div>

                        <div className="show_box show_bg" onClick={() => onHandleDetails(item)}>
                          <p>Details</p>
                        </div>
                      </div>
                      <div className="user_right_contains">
                        {item?.properties?.property_name ? <h6 className="mb-2">{`${item?.properties?.property_name}`}</h6> : '-'}
                      </div>
                      <div className="upcoming_cleanings_flex_div mb-2">
                        <p className="fs-14 fw-400"> {item?.properties?.address}</p>
                        <div className={`show_box ${getBookingStatusClass(item?.booking_status)}`}>
                          <p>{item?.booking_status}</p>
                        </div>
                      </div>
                      <div className="upcoming_cleanings_flex_div mb-2">
                        <div className="amount_div">
                          {hasAccess('accessFinalAmount', getUserRole()) && (
                            <p className="fs-14 black_color fw-400 me-3">{formatAmount(item?.finalAmount) || 0}</p>
                          )}
                          <label className="cleanings_icon_box_div">
                            <img className="img-fluid" src={ShawerIcon} alt="Image" />
                            {item?.properties?.number_of_bathroom || '-'}
                          </label>
                          <label className="cleanings_icon_box_div">
                            <img className="img-fluid" src={BadIcon} alt="Image" />
                            {item?.properties?.number_of_rooms || '-'}
                          </label>
                        </div>
                      </div>
                      <div className="upcoming_cleanings_flex_div">
                        <p className="fs-14 dark_blue_color fw-400">
                          <span> {item?.booking_date_time ? convertTimestampToDate(item?.booking_date_time) : 'N/A'}</span> |{' '}
                          <span>{item?.booking_date_time ? convertTimestampToTime(item?.booking_date_time) : 'N/A'}</span>
                        </p>
                        <div className="">
                          <p className="fs-16 black_color fw-500">{item?.schedule_number && `#${item?.schedule_number}`}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : !loading && (
                <div className="common_card_div upcoming_cleanings_space_div">
                  <p style={{ textAlign: 'center' }}>{`No Data Found`}</p>
                </div>
              )}
        </div>
        {/* Pagination */}
        {allOverview?.scheduledProperties?.length > 0 && (
          <div className="row">
            <div className="col-12 pagination_main_div mt-3">
              <ReactPaginate
                onPageChange={handlePageChange}
                initialPage={currentPage - 1}
                pageCount={pageCount}
                forcePage={currentPage - 1}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel="..."
                containerClassName={'pagination-container'}
                pageClassName={'pagination-page'}
                pageLinkClassName={'pagination-link'}
                previousClassName={'pagination-previous'}
                nextClassName={'pagination-next'}
                activeClassName={'pagination-active'}
                disabledClassName={'pagination-disabled'}
              />
            </div>
          </div>
        )}
        {/* Overview Filter */}
        <OverviewFilter showFilter={showFilter} setShowFilter={setShowFilter} setFilterData={setFilterData} handlePagination={handlePagination} />
        {/* Modal open */}
        {isStatusModalOpen && (
          <StatusModal
            onClose={() => setIsStatusModalOpen(false)}
            title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
            headerContent={{
              name: clientName,
              status: scheduledProperties?.getPropertyScheduleData?.booking_status
            }}
            chatUserId={chatUserId}
            CheckTimeOver={overFun}
            clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
          >
            {['canceled', 'canceled cleaner']?.includes(modalName) && (
              <CancelModalContent
                data={scheduledProperties?.getPropertyScheduleData}
                finalAmount={scheduledProperties?.finalAmount}
                onClose={() => setIsStatusModalOpen(false)}
              />
            )}
            {['scheduled', 'in progress']?.includes(modalName) && (
              <ScheduledModalContent
                data={scheduledProperties?.getPropertyScheduleData}
                setIsRefresh={setIsRefresh}
                onClose={() => setIsStatusModalOpen(false)}
                handlePagination={handlePagination}
                page={`overview`}
              />
            )}
          </StatusModal>
        )}
      </div>
    </div>
  )
}

export default OverView
